import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DeleteOutlined } from '@ant-design/icons';
import { Form, Select, Row, Col, Button as ADButton, Divider, Input } from 'antd';
import { AddButton, Upload } from 'components';
import { useSelector } from 'react-redux';
import { validateFileList } from 'utils/form/validators';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { USUARIOS_FISCALIZACION } from 'constants/nombresCatalogos';
import './Firma.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const Firma = ({ form }) => {
  const firmantes = useSelector(selectCatalogByName(USUARIOS_FISCALIZACION));
  const [selectedIds, setSelectedIds] = useState([]);
  const [usuariosFirmantes, setUsuariosFirmantes] = useState([]);

  const handleChangeFirmantes = (value) => {
    setSelectedIds([value]);
    const newSelectedIds = [];
    const { firmas } = form.getFieldsValue(['firmas']);
    firmas.forEach((f) => {
      if (f !== null && f !== undefined) {
        newSelectedIds.push(f.firmante);
      }
    });
    setSelectedIds(newSelectedIds);
  };

  const setFirmantesForm = (fisca) => {
    setUsuariosFirmantes(fisca);
    const newSelectedIds = [];

    fisca.forEach((f) => {
      if (f !== null && f !== undefined) {
        newSelectedIds.push(f.firmante);
      }
    });
    setSelectedIds(newSelectedIds);
  };

  useEffect(() => {
    const { firmas } = form.getFieldsValue(['firmas']);
    if (firmas.length > 0) {
      setFirmantesForm(firmas);
    }
  }, [usuariosFirmantes]);

  return (
    <div style={{ width: '55em' }}>
      <Form name="dynamic_form_nest_item" className="firmas" form={form}>
        <Row className="firmas-row" gutter={24}>
          <Col xs={12} className="firmas-header-tabla">
            <span>*</span>Nombre de quien firma
          </Col>
          <Col xs={8} className="firmas-header-tabla">
            <span>*</span>Firma digital
          </Col>
          <Col xs={4} className="firmas-header-tabla">
            Acciones
          </Col>
        </Row>
        <Form.List name="firmas" initialValue={[{}]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => {
                const firmante = form.getFieldValue(['firmas', name, 'firmante']);
                return (
                  <Row className="firmas-row" gutter={36}>
                    <Col xs={12}>
                      <Form.Item
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...restField}
                        required
                        name={[name, 'firmante']}
                        rules={[
                          {
                            required: firmante !== null,
                            message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                          }
                        ]}>
                        {firmante !== null ? (
                          <Select
                            placeholder="Selecciona"
                            options={firmantes.map((option) => ({
                              ...option,
                              disabled: selectedIds.includes(option.idUsuario)
                            }))}
                            fieldNames={{
                              value: 'idUsuario',
                              label: 'nombreCompleto'
                            }}
                            // options={firmantes}
                            filterOption={(inputValue, option) =>
                              option.nombreCompleto
                                ?.toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            showSearch
                            onChange={handleChangeFirmantes}
                            destroyOnClose
                          />
                        ) : (
                          <Form.Item name={[name, 'nombreCompletoManual']}>
                            <Input readOnly />
                          </Form.Item>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={8}>
                      <Form.Item
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...restField}
                        name={[name, 'firma']}
                        rules={[
                          {
                            validator: validateFileList
                          }
                        ]}>
                        <Upload
                          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                          accept="image/png, image/jpeg"
                          listType="picture-card"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={4}>
                      <div className="accion-row">
                        <ADButton
                          onClick={() => remove(name)}
                          disabled={fields.length <= 1}
                          className="boton-remover-firma"
                          style={{ fontSize: '22px', height: '2em' }}>
                          <DeleteOutlined />
                        </ADButton>
                      </div>
                    </Col>
                  </Row>
                );
              })}
              <Divider />
              <div className="formulario-firma-acciones">
                <Form.Item>
                  <AddButton onClick={() => add()}>Agregar Nuevo</AddButton>
                </Form.Item>
              </div>
            </>
          )}
        </Form.List>
      </Form>
    </div>
  );
};

Firma.propTypes = {
  form: PropTypes.shape({
    getFieldsValue: PropTypes.func,
    getFieldValue: PropTypes.func
  }).isRequired
};

export default Firma;
